import { createRouter, createWebHistory, RouterView } from 'vue-router';
import { i18n, loadLocaleMessages } from './main.js'; // Import the i18n instance
import { routeGuard, startDatePT, endDatePT } from './routeGuards';

import Home from './Pages/Home/HomePage.vue';
import Upload from './Pages/Upload/Upload.vue';
import FAQ from './Pages/Support/Support.vue';
import Prizes from './Pages/Prizes/Prizes.vue';
import PreProgram from './Pages/Home/Homepagecomponents/PreProgram.vue';
import PostProgram from './Pages/Home/Homepagecomponents/PostProgram.vue';
import ReceiptTroubleshooting from './Pages/ReceiptTroubleshooting/ReceiptTroubleshooting.vue';
import QR from './Pages/QR/QR.vue';

const baseRoutes = [
  {
    path: '',
    redirect: { name: 'Home' },
  },
  {
    path: 'Home',
    name: 'Home',
    component: Home,
    meta: { titleKey: 'Home' }, // Use titleKey to reference the title
    props: { startDate: startDatePT, endDate: endDatePT },
  },
  {
    path: 'Upload',
    name: 'Upload',
    component: Upload,
    meta: { titleKey: 'Upload' },
  },
  {
    path: 'FAQ',
    name: 'FAQ',
    component: FAQ,
    meta: { titleKey: 'Support' },
  },
  {
    path: 'Prizes',
    name: 'Prizes',
    component: Prizes,
    meta: { titleKey: 'Prizes' },
  },
  {
    path: 'QR',
    name: 'QR',
    component: QR,
    meta: { titleKey: 'QR' }, // Use titleKey to reference the title
  },
  {
    path: 'ReceiptTroubleshooting',
    name: 'ReceiptTroubleshooting',
    component: ReceiptTroubleshooting, // our.domain/Faq
    meta: { titleKey: 'ReceiptTroubleshooting' },
  },
  {
    path: 'PreProgram',
    name: 'PreProgram',
    component: PreProgram,
    meta: { titleKey: 'PreProgram', hideNav: true },
    props: { startDate: startDatePT },
  },
  {
    path: 'PostProgram',
    name: 'PostProgram',
    component: PostProgram,
    meta: { titleKey: 'PostProgram', hideNav: true },
    props: { endDate: endDatePT },
  },
  { path: ':notFound(.*)', redirect: { name: 'Home' } },
];

const routes = [
  {
    path: '/:locale(fr)?',
    component: RouterView,
    children: baseRoutes
  }
];

// Create the router
const router = createRouter({
  linkActiveClass: 'active',
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

// Dynamically set language and page title based on route
router.beforeEach(async (to, from, next) => {
  const paramLocale = to.params.locale === 'fr' ? 'fr' : 'en';
  document.documentElement.lang = paramLocale;

  if (i18n.global.locale.value !== paramLocale) {
    await loadLocaleMessages(paramLocale);
    i18n.global.locale.value = paramLocale;
    localStorage.setItem('locale', paramLocale);
  }

  const pageTitleKey = to.meta.titleKey; // Access the title key
  if (pageTitleKey) {
    const translatedTitle = i18n.global.t(`titles.${pageTitleKey}`); // Fetch translated title using i18n
    document.title = translatedTitle || 'Default Title'; // Set the page title dynamically
  }

  next();
});

router.beforeEach(routeGuard);

export default router;
